import React, { PureComponent } from "react";

import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

import {
  CustomizedXAxisTickTime,
  CustomizedYAxisTickPercentage,
  StandardTooltip,
  selectFormat,
  Error,
} from "./../../../Utils/Utils.js";

import { XRayTooltip } from "./../../../Utils/XRayTooltip/XRayTooltip.js";
import { getXrayTooltipPosition } from "../../../../helpers/DOM";

class EmailPerformance extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      width: 0,
      height: 0,
      tooltip: {
        show: false,
        x: 0,
        y: 0,
      },
    };

    this.divPosition = React.createRef();
    this.updatePosition = this.updatePosition.bind(this);
  }

  updatePosition() {
    this.closeTooltip();

    if (!this.chartRef) return;
    const { containerWidth, containerHeight } = this.chartRef.state;
    this.setState({ width: containerWidth, height: containerHeight });
  }

  UNSAFE_componentWillMount() {
    this.updatePosition();
  }

  componentDidMount() {
    this.props.childRef(this);

    window.addEventListener("resize", this.updatePosition);
    window.addEventListener("click", this.handleClickOutside);

    setTimeout(() => {
      this.updatePosition();
    }, 500);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updatePosition);
    window.removeEventListener("click", this.handleClickOutside);
  }

  closeTooltip = () => {
    this.setState({
      tooltip: { show: false },
    });
  };

  handleClickOutside = (e) => {
    if (
      this.divPosition.current &&
      this.divPosition.current.contains(e.target)
    ) {
      return;
    } else {
      this.closeTooltip();
    }
  };

  getExportData = () => ({
    data: this.props.data.data,
    opts: {
      type: "chart",
    },
  });

  render() {
    const { data } = this.props;

    if (data.hasData === false) {
      return <Error minHeight={360} />;
    }

    return (
      <div ref={this.divPosition}>
        <ResponsiveContainer height={350}>
          <AreaChart
            data={data.data}
            margin={{ top: 12, right: 10, bottom: 0, left: 0 }}
            onClick={(d) => {
              const indicator = "emailPerformance";
              if (d !== null) {
                d.indicator = indicator;
                this.setState({
                  tooltip: { ...d, show: true },
                });
              } else {
                this.closeTooltip();
              }
            }}
          >
            <XAxis
              axisLine={false}
              tickLine={false}
              interval="preserveStartEnd"
              scale="point"
              tick={<CustomizedXAxisTickTime />}
            />
            <YAxis
              axisLine={false}
              tickLine={false}
              mirror={true}
              tick={<CustomizedYAxisTickPercentage />}
            />
            {!this.state.tooltip.show && (
              <Tooltip
                cursor={{ fill: "#eee", opacity: 0.5 }}
                content={
                  <StandardTooltip
                    render={({ data }) => {
                      const payload = data(data);

                      if (payload !== null) {
                        const tooltip_data = payload[0].payload;

                        let content = [];
                        Object.keys(tooltip_data).map((key) => {
                          if (key === "name") {
                            content.push(
                              <div className="standard-tooltip__item" key={key}>
                                <span className="standard-tooltip__key">
                                  Email:
                                </span>
                                <span className="standard-tooltip__value">
                                  {tooltip_data.name.split("-")[1]}
                                </span>
                              </div>
                            );
                          } else {
                            content.push(
                              <div className="standard-tooltip__item" key={key}>
                                <span className="standard-tooltip__key">
                                  <span
                                    className="standard-tooltip__icon"
                                    style={{
                                      background:
                                        key === "click_rate"
                                          ? "#16C8DE"
                                          : "#fc6d52",
                                    }}
                                  ></span>
                                  {key === "click_rate"
                                    ? "Click Rate"
                                    : "Open Rate"}
                                </span>
                                <span className="standard-tooltip__value">
                                  {key === "click_rate"
                                    ? selectFormat(
                                        "percentage",
                                        tooltip_data.click_rate
                                      )
                                    : selectFormat(
                                        "percentage",
                                        tooltip_data.open_rate
                                      )}
                                </span>
                              </div>
                            );
                          }

                          return content;
                        });

                        return (
                          <div className="standard-tooltip">
                            <header className="standard-tooltip__header">
                              <span className="standard-tooltip__key-header">
                                Date:
                              </span>
                              <span className="standard-tooltip__value-header">
                                {tooltip_data.name.split("-")[0]}
                              </span>
                            </header>
                            <main className="standard-tooltip__main">
                              {content}
                            </main>
                          </div>
                        );
                      }
                    }}
                  />
                }
              />
            )}

            <CartesianGrid
              stroke="#FEE5DE"
              strokeDasharray="3 3"
              vertical={false}
            />

            <Area
              type="monotone"
              dataKey="open_rate"
              fillOpacity={0.2}
              fill="#f89481"
              stroke="#fc6d52"
            />
            <Area
              type="monotone"
              dataKey="click_rate"
              fillOpacity={0.2}
              fill="#16C8DE"
              stroke="#16C8DE"
            />
          </AreaChart>
        </ResponsiveContainer>
        {this.state.tooltip.activeCoordinate ? (
          <div
            className="xray-tooltip-container"
            style={{
              top: this.state.tooltip.activeCoordinate.y + 10 + "px",
              left:
                this.state.tooltip.activeCoordinate.x + 1062 + 220 <
                this.state.width
                  ? this.state.tooltip.activeCoordinate.x + 15 + "px"
                  : this.state.tooltip.activeCoordinate.x -
                    getXrayTooltipPosition(
                      this.divPosition.current,
                      this.state.tooltip.activeCoordinate
                    ) +
                    "px",
              opacity: this.state.tooltip.show ? 1.0 : 0.0,
              visibility: this.state.tooltip.show ? "visible" : "hidden",
            }}
          >
            <XRayTooltip
              data={this.state.tooltip}
              close={this.closeTooltip.bind(this)}
            />
          </div>
        ) : null}
      </div>
    );
  }
}

export default EmailPerformance;
